import { Routes } from '@angular/router';

import { LoggedOutGuard, LoggedInGuard } from '@shared/guards';
import { UserRole } from '@shared/models';

export const appRoutes: Routes = [
  {
    path: 'notfound',
    loadComponent: () => import('./auth/components/not-found/notfound.component').then((m) => m.NotFoundComponent),
    data: { breadcrumb: 'breadcrumb.notFound' },
  },
  {
    path: 'landing',
    loadChildren: () => import('./landing/landing.routes').then((m) => m.landingRoutes),
    canActivate: [LoggedOutGuard],
  },
  {
    path: 'auth',
    canActivate: [LoggedOutGuard],
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
    data: { breadcrumb: 'auth.login.welcomeBack' },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./legal/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./legal/terms-of-use/terms-of-use.component').then((m) => m.TermsOfUseComponent),
  },
  {
    path: 'worker',
    loadComponent: () => import('./worker/worker.component').then((m) => m.WorkerComponent),
  },
  {
    path: 'app',
    loadComponent: () => import('./_layout/app.layout.component').then((m) => m.AppLayoutComponent),
    canActivate: [LoggedInGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
        data: {
          roles: [
            UserRole.Admin,
            UserRole.Agent,
            UserRole.Ceo,
            UserRole.Stakeholder,
            UserRole.ProjectManager,
            UserRole.Foreman,
            UserRole.HR,
          ],
        },
      },
      {
        path: 'master-data',
        loadChildren: () => import('./master-data/master-data.routes').then((m) => m.masterDataRoutes),
        data: { roles: [UserRole.Admin, UserRole.Agent, UserRole.Ceo, UserRole.Stakeholder, UserRole.ProjectManager] },
      },
      {
        path: 'project',
        loadChildren: () => import('./project/project.routes').then((m) => m.projectRoutes),
        data: {
          roles: [
            UserRole.Admin,
            UserRole.Agent,
            UserRole.Ceo,
            UserRole.Stakeholder,
            UserRole.ProjectManager,
            UserRole.Foreman,
            UserRole.HR,
          ],
        },
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.settingsRoutes),
        data: {
          breadcrumb: 'breadcrumb.settings',
          roles: [
            UserRole.Admin,
            UserRole.Agent,
            UserRole.Ceo,
            UserRole.Stakeholder,
            UserRole.ProjectManager,
            UserRole.Foreman,
          ],
        },
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.routes').then((m) => m.reportsRoutes),
        data: {
          breadcrumb: 'breadcrumb.reports',
          roles: [UserRole.Admin, UserRole.Agent, UserRole.Ceo, UserRole.Stakeholder, UserRole.ProjectManager],
        },
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes),
        canActivate: [LoggedInGuard],
        data: { breadcrumb: 'breadcrumb.admin', roles: [UserRole.Admin] },
      },
      {
        path: 'e-learning',
        loadChildren: () => import('./e-learning/e-learning.routes').then((m) => m.eLearningRoutes),
        canActivate: [LoggedInGuard],
        data: { breadcrumb: 'breadcrumb.eLearning', roles: [UserRole.Admin, UserRole.LearningManager] },
      },
      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  { path: '**', redirectTo: '/landing' },
];
